import { component } from 'picoapp';
import Drawer from 'utils/drawer';

export default component((node) => {
  document.body.appendChild(node);

  const drawer = Drawer(node);
  const triggers = [...document.querySelectorAll<HTMLElement>('[data-trigger="mobile-nav"]')];

  if (!drawer || !triggers.length) return;

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const navItems = [...node.querySelectorAll<HTMLElement>('[data-nav-item]')];

      drawer.toggle();

      navItems.forEach((item, index) => {
        item.classList.add('opacity-0');
        item.classList.remove('opacity-100');
        item.classList.add('animate-fade-bottom-top');
        item.style.animation = `fade-bottom-top 0.5s ease forwards ${index * 0.1}s`;
        item.addEventListener('animationend', () => {
          item.classList.add('opacity-100');
          item.classList.remove('opacity-0');
          item.style.animation = '';
        });
      });
    });
  });

  const subdrawers: NodeListOf<HTMLElement> = node.querySelectorAll('[data-subdrawer]');
  subdrawers.forEach((item) => {
    const subTriggersClose = [...item.querySelectorAll<HTMLElement>('[data-trigger="subdrawer-close"]')];
    const subTriggersCloseAll = [...item.querySelectorAll<HTMLElement>('[data-trigger="subdrawer-close-all"]')];
    const sub = Drawer(item);
    const parentDrawer = item.parentElement.closest('.drawer');
    sub.on('open', () => {
      parentDrawer.classList.add('drawer--flyout');
    });

    sub.on('closed', () => {
      parentDrawer.classList.remove('drawer--flyout');
    });

    document.addEventListener('click', (e) => {
      const target = e.target as HTMLAnchorElement;

      if (target && target?.dataset?.trigger === `subdrawer:${item.id}`) {
        e.preventDefault();
        sub.open();
      }
    });

    subTriggersClose.forEach((subTrigger) => {
      subTrigger.addEventListener('click', () => {
        sub.close();
      });
    });

    subTriggersCloseAll.forEach((subTrigger) => {
      subTrigger.addEventListener('click', () => {
        sub.close();
        drawer.close();
      });
    });
  });
});
